import LoadingGif from "@merchstores/shared/assets/common/Flask-3s-200px.svg"

export interface ILoadingProps {
  isLoading: boolean
}

export const Loading: React.FC<ILoadingProps> = (props: ILoadingProps) => {
  const isLoading = props.isLoading;

  if (isLoading)
  {
    return (<div 
      className="h-screen flex items-center justify-center"
      data-loading={isLoading}>
      <img 
        src={LoadingGif} 
        alt="loading flask" 
        width="100px" />
    </div>)
  }

  return (
    <div data-loading={isLoading}></div>
  )
}

